/**
 * Limpieza de persistencia legacy (deep link / iframe SSO).
 * La sesión activa vive en Vuex `loginVendedora` (persistedstate).
 */

const FLAG_KEY = 'lms_sesion_vendedora'
const SSO_KEY = 'lms_rh_sso_payload'
/** Clave legacy del deep link (Capacitor Storage / Preferences). */
const LEGACY_CAP_KEY = 'modo_vendedora'

export function clearSesionVendedora () {
  try {
    sessionStorage.removeItem(FLAG_KEY)
    sessionStorage.removeItem(SSO_KEY)
  } catch (e) {
    // ignore
  }
}

/**
 * Limpia flag legacy del deep link (Capacitor) sin tocar la sesión RH actual.
 */
export async function limpiarSoloLegacyCapacitor () {
  try {
    const { Preferences } = await import('@capacitor/preferences')
    await Preferences.remove({ key: LEGACY_CAP_KEY })
  } catch (e) {
    // ignore plugin/web
  }
  try {
    localStorage.removeItem(LEGACY_CAP_KEY)
    localStorage.removeItem(`CapacitorStorage.${LEGACY_CAP_KEY}`)
  } catch (e) {
    // ignore
  }
}

/**
 * Limpia flag legacy del deep link y restos de sesión iframe.
 */
export async function limpiarPersistenciaVendedoraLegacy () {
  clearSesionVendedora()
  await limpiarSoloLegacyCapacitor()
}
